<template>
  <div class="home">
    <HeaderLandingNew />
    <div class="section-one section-missions">
      <div class="so-content">
        <h1>Missions</h1>
        <p>
          Donate to MusicVerse to support missions MusicVerse is also a 501c3
          organization that can provide tax deductible receipts for US
        </p>
        <div class="so-content-action">
          <a
            class="btn-n primary"
            aria-label="Learn More MusicVerse"
            :href="url"
          >
            Explore Missions
          </a>
        </div>
      </div>
    </div>
    <div class="container-section donat-list">
      <div
        class="content-section-2"
        v-for="item in dataDonations"
        :key="item.id"
      >
        <div class="donat-list-item">
          <b-carousel
            :id="`carousel-${item.id}`"
            :interval="4000"
            fade
            controls
            img-width="100%"
            img-height="auto"
          >
            <b-carousel-slide
              class="custom-image-slider"
              v-for="(image, index) in item.images"
              :img-src="image"
              :key="index"
            ></b-carousel-slide>
          </b-carousel>
          <div class="dli-info">
            <div class="dli-top">
              <h4>{{ item.name }}</h4>
              <p>{{ item.description }}</p>
            </div>
            <div class="dli-bottom">
              <a
                @click="donate(item.id)"
                class="btn-n primary"
                style="width: 100%"
                >Donate to {{ item.name }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterLandingNew />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HeaderLandingNew from "@/components/HeaderLandingNew";
import FooterLandingNew from "@/components/FooterLandingNew";
import helperMixins from "@/mixins/helpers.mixins";
export default {
  name: "DonationPage",
  mixins: [helperMixins],
  data: () => ({
    url: "/#/premium?section=premium",
    dataDonations: [],
  }),
  computed: {
    ...mapGetters("DonationsModule", ["listOnGoingAnon"]),
  },
  watch: {
    listOnGoingAnon: {
      immediate: true,
      deep: true,
      async handler(val) {
        if (val.data !== undefined) {
          this.dataDonations = val.data.map((donat) => ({
            id: donat.id,
            name: donat.organization,
            images: donat.banner,
            description: donat.description,
            total_donation: parseFloat(donat.total_donation).toFixed(2),
          }));
        }
      },
    },
  },
  async mounted() {
    await this.requestOnGoingAnon();
  },
  methods: {
    ...mapActions("DonationsModule", ["requestOnGoingAnon"]),
    ...mapActions("NotificationModule", ["setNextPage"]),
    donate(id) {
      this.setNextPage(`DonationsPage?_d=${id}`);
      this.$router.push({ name: "DonationsPage", query: { _d: id } });
    },
  },
  components: {
    HeaderLandingNew,
    FooterLandingNew,
  },
};
</script>

<style>
@import "../assets/stylesheets/landing.css";
.section-missions {
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.32) 0%, rgba(0, 0, 0, 0.32) 100%),
    url("~@/assets/bg-missions.jpg"),
    lightgray 0px -2.409px / 100% 112.294% no-repeat;
}
.section-missions .so-content p {
  width: 730px;
}
.donat-list {
  display: flex;
  flex-direction: column;
  gap: 64px;
}
.donat-list .donat-list-item {
  display: flex;
  gap: 64px;
}
.donat-list .donat-list-item .carousel,
.donat-list .donat-list-item .carousel .carousel-inner {
  width: 444px !important;
  height: 296px !important;
}
.donat-list .donat-list-item img {
  width: 100% !important;
  height: auto !important;
  object-fit: cover;
}
.donat-list .donat-list-item .dli-info .dli-top,
.donat-list .donat-list-item .dli-info .dli-bottom {
  padding: 16px 24px;
}
.donat-list .donat-list-item .dli-info h4 {
  font-size: 24px;
  font-weight: 700;
  line-height: 138%;
  margin-bottom: 40px;
}
.donat-list .donat-list-item .dli-info p {
  border-bottom: 1px solid rgba(128, 128, 128, 0.5);
  padding-bottom: 1rem;
  margin-bottom: 0;
}

@media screen and (max-width: 500px) {
  .section-missions {
    background-position: 50% 100%;
  }
  .section-missions .so-content p {
    width: 100%;
  }
  .donat-list .donat-list-item {
    flex-direction: column;
  }
  .donat-list .donat-list-item .carousel,
  .donat-list .donat-list-item .carousel .carousel-inner {
    width: 100% !important;
    height: auto !important;
  }
  .donat-list .donat-list-item .dli-info .dli-top,
  .donat-list .donat-list-item .dli-info .dli-bottom {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DonationPage.vue